import { isDefined } from "@perxis-auto/shared/lib/lib/is/isDefined";
import { DEFAULT_CREDIT_LIMITS_VALUES } from "../../config/credit.js";
import "@hey-api/client-fetch";
import { CreditType } from "../../api/types.gen.js";
import { calculateValueFromPercentage } from "./calculateValueFromPercentage.js";
import { normalizeRangeValue } from "./normalizeRangeValue.js";
const calcCreditValues = (choice, scope) => {
  var _a, _b, _c;
  const downPayment = normalizeRangeValue(
    choice.downPayment ?? DEFAULT_CREDIT_LIMITS_VALUES.downPayment,
    scope.downPayment
  );
  const residualPayment = choice.type === CreditType.RESIDUAL_PAYMENT ? normalizeRangeValue(
    choice.residualPayment ?? DEFAULT_CREDIT_LIMITS_VALUES.residualPayment,
    scope.residualPayment
  ) : null;
  const downPaymentAmount = calculateValueFromPercentage(choice.price, downPayment);
  const residualPaymentAmount = choice.type === CreditType.RESIDUAL_PAYMENT && residualPayment ? calculateValueFromPercentage(choice.price, residualPayment) : null;
  const isNumberOfPeriodsIncludes = isDefined(choice.numberOfPeriods) && isDefined(scope.numberOfPeriods) && ((_a = scope == null ? void 0 : scope.numberOfPeriods) == null ? void 0 : _a.includes(choice.numberOfPeriods));
  const selectedNumberOfPeriods = isNumberOfPeriodsIncludes ? choice.numberOfPeriods : DEFAULT_CREDIT_LIMITS_VALUES.numberOfPeriods;
  const numberOfPeriods = normalizeRangeValue(selectedNumberOfPeriods, {
    min: (_b = scope == null ? void 0 : scope.numberOfPeriods) == null ? void 0 : _b[0],
    max: (_c = scope == null ? void 0 : scope.numberOfPeriods) == null ? void 0 : _c[scope.numberOfPeriods.length - 1]
  });
  return {
    type: choice.type ?? CreditType.ANNUITY,
    downPayment,
    downPaymentAmount,
    residualPayment,
    residualPaymentAmount,
    numberOfPeriods
  };
};
export {
  calcCreditValues
};
